import { render, staticRenderFns } from "./DynamicComponent.vue?vue&type=template&id=1e65e44a&"
import script from "./DynamicComponent.vue?vue&type=script&lang=ts&"
export * from "./DynamicComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports